import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

export const ErrorFallback = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-centre p-4 bg-background">
      <Card className="max-w-md w-full p-6 text-centre">
        <h1 className="text-2xl font-bold mb-4 text-foreground">
          Oops! Something went wrong
        </h1>
        <p className="text-muted-foreground mb-6">
          We've been notified and are working to fix the issue.
        </p>
        <Button 
          onClick={() => window.location.href = '/'}
          className="w-full"
        >
          Return to home page
        </Button>
      </Card>
    </div>
  );
};
